// 创建a标签
export function createNodeElement_a(flow, type, title) {
  let a = document.createElement("a"),
    blob = new Blob([flow], { type }),
    url = window.URL.createObjectURL(blob);
  a.setAttribute("href", url);
  a.setAttribute("target", "_blank");
  a.style.opacity = 0;
  a.download = title || "报告";
  a.click();
  // 释放
  window.URL.revokeObjectURL(url);
}